/**
 * Umožňuje uvolnění zdrojů
 * @generateInstanceClass
 */
export interface IDisposable {
    dispose(): void;
}

export class IDisposable {
    public static get [Symbol.hasInstance](): (instance: any) => boolean {
        return (instance: any) => instance != null && typeof instance.dispose === "function";
    }
}

/**
 * Umožňuje uvolnění zdrojů na které lze asynchronně čekat
 * @generateInstanceClass
 */
export interface IDisposableAsync {
    dispose(): Promise<void>;
}

export class IDisposableAsync {
    public static get [Symbol.hasInstance](): (instance: any) => boolean {
        return (instance: any) => instance != null && typeof instance.dispose === "function";
    }
}
